import React, { useState } from "react";
import { clientApi, formatApiError } from "@/lib/http";
import { RescheduleDialog, fmtWhen } from "@/components/public/ClientPortal";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { CalendarDays, RotateCcw, X } from "lucide-react";

// Shown to a signed-in client at the start of the booking flow so they reschedule instead of double-booking.
export const UpcomingPanel = ({ slug, upcoming, onChanged }) => {
  const [resched, setResched] = useState(null);
  if (!upcoming?.length) return null;
  const cancel = async (b) => {
    if (!window.confirm(`Cancel your ${b.service_name} on ${fmtWhen(b.start)}?`)) return;
    try { await clientApi.post(`/public/client/bookings/${b.id}/cancel`); toast.success("Appointment cancelled"); onChanged?.(); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail) || "Couldn't cancel"); }
  };
  return (
    <div className="rounded-xl border border-primary/30 bg-primary/5 p-4 mb-5" data-testid="pub-upcoming-panel">
      <div className="flex items-center gap-2 mb-1"><CalendarDays className="h-4 w-4 text-primary" /><span className="font-heading font-bold">You already have {upcoming.length === 1 ? "an appointment" : `${upcoming.length} appointments`} booked</span></div>
      <p className="text-xs text-muted-foreground mb-3">Need a different time? Reschedule it here instead of booking again — any deposit moves with it.</p>
      <ul className="space-y-2">
        {upcoming.map((b) => (
          <li key={b.id} className="flex flex-wrap items-center justify-between gap-2 rounded-lg bg-background border border-border px-3 py-2 text-sm" data-testid={`pub-upcoming-${b.id}`}>
            <div><div className="font-medium">{b.service_name}</div><div className="text-xs text-muted-foreground">{fmtWhen(b.start)}{b.deposit_paid ? " · deposit paid" : ""}</div></div>
            <div className="flex gap-2">
              <Button size="sm" variant="outline" className="rounded-lg h-8" onClick={() => setResched(b)} data-testid={`pub-reschedule-${b.id}`}><RotateCcw className="h-3.5 w-3.5 mr-1" />Reschedule</Button>
              <Button size="sm" variant="ghost" className="rounded-lg h-8 text-muted-foreground" onClick={() => cancel(b)} data-testid={`pub-cancel-${b.id}`}><X className="h-3.5 w-3.5 mr-1" />Cancel</Button>
            </div>
          </li>
        ))}
      </ul>
      <p className="text-xs text-muted-foreground mt-3">Or carry on below to book something new.</p>
      <RescheduleDialog slug={slug} booking={resched} open={!!resched} onOpenChange={(o) => !o && setResched(null)} onDone={() => { setResched(null); onChanged?.(); }} />
    </div>
  );
};
